import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp, toHTTPParam } from '../../../core';
import { TituloReceberSearchVencidos } from './titulo-receber-vencidos';
import { TituloReceberFilter, TituloReceberVencidosFilter } from '../filter';
import { TituloReceberVencidosTotal } from './titulo-receber-vencidos-total';

@Injectable({
    providedIn: 'root'
})
export class TituloReceberVencidosHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/tituloreceber/0/vencidos`
    }

    /** Pesquisa os títulos vencidos */
    search(filter: TituloReceberVencidosFilter): Observable<TituloReceberSearchVencidos> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<TituloReceberSearchVencidos>(this.pathApi, {params});
    }

    /** Obtem a quantidade de títulos vencidos para a pessoa na data atual */
    getCount(idPessoa: number, idRepresentante: number): Observable<number> {
        // Params
        const params = new HttpParams()
                            .append('idPessoa', idPessoa ? idPessoa.toString() : null)
                            .append('idRepresentante', idRepresentante ? idRepresentante.toString() : null);

        return this.customHttp.get<number>(`${this.pathApi}/quantidade`, {params});
    }

    /** Obtem os totais de títulos vencidos no geral até a data base informada */
    getVencidosTotalGeral(filter: TituloReceberFilter, dataBase: Date): Observable<TituloReceberVencidosTotal> {
        // Params
        let params = new HttpParams()
                            .append('dataBase', toHTTPParam(dataBase));
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get(`${this.pathApi}/total/geral`, {params});
    }

    /** Obtem os totais de títulos vencidos há 30 dias através da data base */
    getVencidosTotal30Dias(filter: TituloReceberFilter, dataBase: Date): Observable<TituloReceberVencidosTotal> {
        // Params
        let params = new HttpParams()
                            .append('dataBase', toHTTPParam(dataBase));
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get(`${this.pathApi}/total/30dias`, {params});
    }
}
